/**
 * Routes: / (start screen) and /drafts/:id (the editor). History API, no router library.
 * Inside PRISM (a frame), the editor waits for host:init and opens what PRISM asked for instead (EmbeddedApp).
 */
import { useEffect, useState } from 'react';
import { api, type ClientConfig } from './api.ts';
import { EditorPage } from './EditorPage.tsx';
import { EmbeddedApp } from './prism/EmbeddedApp.tsx';
import { StartScreen } from './StartScreen.tsx';

function draftFromPath(path: string): string | undefined {
  return /^\/drafts\/([0-9a-f-]{36})\/?$/.exec(path)?.[1];
}

const embedded = window.parent !== window;

export function App() {
  const [path, setPath] = useState(window.location.pathname);
  const [config, setConfig] = useState<ClientConfig>();
  const [configError, setConfigError] = useState<string>();
  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener('popstate', onPop);
    api.config().then(setConfig, (e: Error) => setConfigError(e.message));
    return () => window.removeEventListener('popstate', onPop);
  }, []);
  if (embedded) return <EmbeddedApp config={config} configError={configError} />;
  const go = (p: string) => {
    window.history.pushState(null, '', p);
    setPath(p);
  };
  const draftId = draftFromPath(path);
  if (draftId) return <EditorPage key={draftId} draftId={draftId} config={config} onHome={() => go('/')} />;
  return <StartScreen onOpen={(id) => go(`/drafts/${id}`)} />;
}
